module.exports = __webpack_public_path__ + "img/0Q3A2365_P_L_WoodMatted_MockedUp.c582c8e9.jpg";